var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5714 21H14.9286C13.5868 21 12.5 20.0056 12.5 18.7778V13.2222C12.5 11.9944 13.5868 11 14.9286 11H18.5714C19.9132 11 21 11.9944 21 13.2222V18.7778C21 20.0056 19.9132 21 18.5714 21Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5714 8H14.9286C13.5868 8 12.5 6.95583 12.5 5.66667V3.33333C12.5 2.04417 13.5868 1 14.9286 1H18.5714C19.9132 1 21 2.04417 21 3.33333V5.66667C21 6.95583 19.9132 8 18.5714 8Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.42857 1H7.07143C8.41321 1 9.5 1.99444 9.5 3.22222V8.77778C9.5 10.0056 8.41321 11 7.07143 11H3.42857C2.08679 11 1 10.0056 1 8.77778V3.22222C1 1.99444 2.08679 1 3.42857 1Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.42857 14H7.07143C8.41321 14 9.5 15.0442 9.5 16.3333V18.6667C9.5 19.9558 8.41321 21 7.07143 21H3.42857C2.08679 21 1 19.9558 1 18.6667V16.3333C1 15.0442 2.08679 14 3.42857 14Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.3e122526fe46f36df5aacc070fc23345.svg";
export { ForwardRef as ReactComponent };